import {
  NavParams
} from 'ionic-angular/navigation/nav-params';
import {
  Component,
  ViewChild,
  OnInit,
  Host,
  OnDestroy
} from '@angular/core';
import {
  DocumentCirculationService
} from './../../../providers/document-circulation.service';
import {
  RunningDocument,
  Provider,
  RunningDocumentInfo,
  LastDates,
  DateInterval
} from '../model/index';
import {
  Observable
} from 'rxjs/Rx';
import {
  Subscription
} from 'rxjs/Subscription';
import {
  FileUploader
} from 'ng2-file-upload';
import {
  Location
} from '@angular/common';
/*import {
  dns
} from "../../../providers/global.config";*/
import {
  Events
} from 'ionic-angular/util/events';
import {
  DocCirc
} from './doc-circ-aff/doc-circ';
import {
  ModalController
} from 'ionic-angular/components/modal/modal-controller';


@Component({
  templateUrl: 'documentcirculation.html'
})

export class DocumentCirculationComponent {
  currentuser: any;
  insuranceProviders: Provider[] = [];
  otherProviders: Provider[] = [];
  idVehicule: any;
  matricule: any;
  idProvider: number = 0;
  listInsurance: RunningDocumentInfo[] = [];
  listVisit: RunningDocumentInfo[] = [];
  listCertification: RunningDocumentInfo[] = [];
  listPermit: RunningDocumentInfo[] = [];
  listTaxe: RunningDocumentInfo[] = [];
  insurance: RunningDocument = new RunningDocument();
  operationTime: Date;
  endTime: Date;
  showInsurance: boolean = false;
  showVisit: boolean = false;
  showCertification: boolean = false;
  showPermit: boolean = false;
  showTaxe: boolean = false;
  click: boolean = false;
  insuranceRequest: boolean = true;
  visitRequest: boolean = true;
  certificationRequest: boolean = true;
  permitRequest: boolean = true;
  taxeRequest: boolean = true;
  download: boolean = true;
  showProvider: boolean = false;
  providerName: string = null;
  datesExpiration: LastDates = new LastDates();
  dateinsurance: any;
  datevisit: any;
  datecertification: any;
  datetaxe: any;
  datepermit: any;
  indexFile: number = -1;
  item: any = null;
  subscriptionVehicule: Subscription;
  subscriptionUpload: Subscription;
  //dns: string = dns;
  date: DateInterval = new DateInterval();

  public uploader: FileUploader = new FileUploader({
   // url: dns + 'upload'
  });

  constructor(private documentService: DocumentCirculationService, public events: Events, public navParams: NavParams, public modalCtrl: ModalController) {
    this.idVehicule = navParams.data.idDevice.idVehicule;
    this.matricule = navParams.data.matricule;
  }

  ngAfterViewInit() {
    this.currentuser = JSON.parse(localStorage.getItem('currentuser'));
    this.uploader.authToken = this.currentuser.token;
    this.documentService.getProviders("INSURANCE").subscribe(response => {
      this.insuranceProviders = response;
    });

    this.documentService.getProviders("OTHER").subscribe(response => {
      this.otherProviders = response;
    });
    this.datesExpiration = new LastDates();
    this.insuranceRequest = true;
    this.visitRequest = true;
    this.certificationRequest = true;
    this.permitRequest = true;
    this.taxeRequest = true;
    this.documentService.getExpirationDates(this.idVehicule).subscribe(response => {
      if (response.insurance != null){
        this.datesExpiration.insurance = new Date(response.insurance);
        this.dateinsurance = this.datesExpiration.insurance.toISOString();
      }

      if (response.visit != null){
        this.datesExpiration.visit = new Date(response.visit);
        this.datevisit = this.datesExpiration.visit.toISOString();
      }
      if (response.certification != null){
        this.datesExpiration.certification = new Date(response.certification);
        this.datecertification = this.datesExpiration.certification.toISOString();
      }
      if (response.taxe != null){
        this.datesExpiration.taxe = new Date(response.taxe);
        this.datetaxe = this.datesExpiration.taxe.toISOString();
      }
      if (response.permit != null){
        this.datesExpiration.permit = new Date(response.permit);
        this.datepermit = this.datesExpiration.permit.toISOString();
      }

      if (this.datesExpiration.insurance == null) {
        this.datesExpiration.insurance = new Date(1483142400000);
        this.dateinsurance = this.datesExpiration.insurance.toISOString();
      }
      if (this.datesExpiration.visit == null) {
        this.datesExpiration.visit = new Date(1483142400000);
        this.datevisit = this.datesExpiration.visit.toISOString();
      }
      if (this.datesExpiration.certification == null) {
        this.datesExpiration.certification = new Date(1483142400000);
        this.datecertification = this.datesExpiration.certification.toISOString();
      }
      if (this.datesExpiration.taxe == null) {
        this.datesExpiration.taxe = new Date(1483142400000);
        this.datetaxe = this.datesExpiration.taxe.toISOString();
      }
      if (this.datesExpiration.permit == null) {
        this.datesExpiration.permit = new Date(1483142400000);
        this.datepermit = this.datesExpiration.permit.toISOString();
      }
    });
    this.subscriptionUpload = Observable.interval(100).subscribe(x => {
      this.uploader.onAfterAddingFile = (file) => {
        file.withCredentials = false;
      };

      if (this.item != null && this.indexFile >= 0)
        if (this.uploader.queue.length > 0) {
          if (this.uploader.queue[this.indexFile] != undefined && this.uploader.queue[this.indexFile].isSuccess) {
            this.item.isSuccess = false;
            this.item.remove();
            this.documentService.readData(this.idVehicule, this.insurance.type, this.item.file.name).subscribe(response => {
              if (response.length > 0) {
                for (let i = 0; i < response.length; i++) {
                  if (this.insurance.type == "INSURANCE") {
                    this.listInsurance.push(response[i]);
                    if (this.datesExpiration.insurance.getTime() < response[i].endTime) {
                      this.datesExpiration.insurance = new Date(response[i].endTime);
                      this.dateinsurance = this.datesExpiration.insurance.toISOString();


                    }
                  }
                  if (this.insurance.type == "VISIT") {
                    this.listVisit.push(response[i]);
                    if (this.datesExpiration.visit.getTime() < response[i].endTime) {
                      this.datesExpiration.visit = new Date(response[i].endTime);
                      this.datevisit = this.datesExpiration.visit.toISOString();

                    }
                  }
                  if (this.insurance.type == "OPERATIONAL_CERTIFICATION") {
                    this.listCertification.push(response[i]);
                    if (this.datesExpiration.certification.getTime() < response[i].endTime) {
                      this.datesExpiration.certification = new Date(response[i].endTime);
                      this.datecertification = this.datesExpiration.certification.toISOString();

                    }
                  }
                  if (this.insurance.type == "PERMIT_CIRCULATION") {
                    this.listPermit.push(response[i]);
                    if (this.datesExpiration.permit.getTime() < response[i].endTime) {
                      this.datesExpiration.permit = new Date(response[i].endTime);
                      this.datepermit = this.datesExpiration.permit.toISOString();

                    }
                  }
                  if (this.insurance.type == "ROAD_TAXES") {
                    this.listTaxe.push(response[i]);
                    if (this.datesExpiration.taxe.getTime() < response[i].endTime) {
                      this.datesExpiration.taxe = new Date(response[i].endTime);
                      this.datetaxe = this.datesExpiration.taxe.toISOString();

                    }
                  }
                }
              } else {}
            }, () => {});
            this.item = null;
          }
        }
    });
    this.config();


  }
  config() {
    this.operationTime = new Date();
    this.endTime = new Date();
    this.endTime.setFullYear(this.endTime.getFullYear() + 1);
    this.insurance.cost = 0;
    this.insurance.id = 0;
  }
  closeModal() {
    this.events.publish('Dismiss', null);
  }

  changeType(type: string) {
    this.insurance.type = type;
  }

  loadListInsurance() {
    if (this.insuranceProviders.length > 0) {
      this.idProvider = this.insuranceProviders[0].id;
      this.showProvider = false;
    }
    this.changeType("INSURANCE");
    this.listInsurance = [];
    this.documentService.getListDocuments(this.idVehicule, this.insurance.type).subscribe(response => {
      let data={insurance:this.insurance,listInsurance:response,datesExpiration:this.datesExpiration,idVehicule:this.idVehicule}
      let doccirc = this.modalCtrl.create(DocCirc,{data})
    doccirc.present();
    });
    
    if (this.insuranceProviders.length > 0) {
      this.idProvider = this.insuranceProviders[0].id;
    }
  }
  loadListVisit() {
 
    this.changeType("VISIT");
    if (this.visitRequest) {
        this.listVisit = [];
        this.documentService.getListDocuments(this.idVehicule, this.insurance.type).subscribe(response => {
          let data={insurance:this.insurance,listInsurance:response,datesExpiration:this.datesExpiration,idVehicule:this.idVehicule}
          let doccirc = this.modalCtrl.create(DocCirc,{data})
            doccirc.present();
        });
    }
    
    if (this.otherProviders.length > 0) {
        this.idProvider = this.otherProviders[0].id;
    }
}

loadListCertification() {

    this.changeType("OPERATIONAL_CERTIFICATION");

    if (this.certificationRequest) {
        this.listCertification = [];
        this.documentService.getListDocuments(this.idVehicule, this.insurance.type).subscribe(response => {
          let data={insurance:this.insurance,listInsurance:response,datesExpiration:this.datesExpiration,idVehicule:this.idVehicule}
          let doccirc = this.modalCtrl.create(DocCirc,{data})
            doccirc.present();
        });
    }
}

loadListPermit() {
  
    this.changeType("PERMIT_CIRCULATION");
    if (this.permitRequest) {
        this.listPermit = [];
        this.documentService.getListDocuments(this.idVehicule, this.insurance.type).subscribe(response => {
          let data={insurance:this.insurance,listInsurance:response,datesExpiration:this.datesExpiration,idVehicule:this.idVehicule}
          let doccirc = this.modalCtrl.create(DocCirc,{data})
          doccirc.present();
        });
    }
   
    if (this.otherProviders.length > 0) {
        this.idProvider = this.otherProviders[0].id;
    }
}

loadListTaxe() {
  
    this.changeType("ROAD_TAXES");
    if (this.taxeRequest) {
        this.listTaxe = [];
        this.documentService.getListDocuments(this.idVehicule, this.insurance.type).subscribe(response => {
          let data={insurance:this.insurance,listInsurance:response,datesExpiration:this.datesExpiration,idVehicule:this.idVehicule}
          let doccirc = this.modalCtrl.create(DocCirc,{data})
          doccirc.present();
        });
    }
  
    if (this.otherProviders.length > 0) {
        this.idProvider = this.otherProviders[0].id;
    }
}

}



// WEBPACK FOOTER //
// ./src/pages/gestion-park/documentcirculation/documentcirculation.ts